<template>
    <div>
        <nav-header></nav-header>
        <div class="edituser-form validate-form p-l-50 p-r-50 p-t-10 p-b-75" >
            <section class="page-content">
                <div id="notify" ref="notify" class="signup-form-title p-b-20"></div>
                <div class="page-title">
                    <h2>Editar Usuário</h2>
                </div>
                <hr/><br>
                <div class="wrap-form-fields" style="align: center">
                    <div class="input-container">
                        <i class="fa fa-user icon"></i>
                        <label class="label-input">Nome:</label>
                        <input v-model="name" type="name" id="inputName" class="input-field" />
                    </div>
                    <br />
                    <div class="input-container">
                        <i class="fa fa-envelope icon"></i>
                        <label class="label-input">Email:</label>
                        <input v-model="email" type="email" id="inputEmail" class="input-field" />
                    </div>
                    <br />
                    <label class="label-input">Permissão:</label>
                    <b-form-select
                        v-model="selectedRole"
                        :options="optionsRole"
                        style="font-size: 20px"
                        v-if="loggedUserRole == 'ADMIN_EMPRESA' && selectedRole != 'ADMIN_CEPE'"
                    ></b-form-select>
                    <b-form-select
                        v-model="selectedRole"
                        :options="optionsCompany"
                        style="font-size: 20px"
                        v-else-if="selectedRole == 'ADMIN_CEPE'" disabled
                    ></b-form-select>
                    <b-form-select
                        v-model="selectedRole"
                        :options="optionsCompany"
                        style="font-size: 20px"
                        v-else
                    ></b-form-select>
                    <br /><br/>
                    <br/>
                </div>
                <button class="btn btn-secondary" v-on:click="$router.push({name:'userManagement'})" style="aling: left; margin-left: 10px">Cancelar</button>
                <button class="btn btn-primary" v-on:click="this.updateUser" style="aling: left">Confirmar</button>
            </section>
        </div>
        <user-profile-footer></user-profile-footer>
    </div>
</template>

<style scoped>
    .footer {
        position: inherit !important;
    }
</style>

<script>
    import axios from 'axios'
    import config from '../helpers/generalConfig';
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue'

    export default {
        components: { NavHeader, UserProfileFooter },

        data() {
            return {
                loggedUserRole:'',
                userRole: '',
                companies: null,
                id: this.$route.params.id,
                name: '',
                email: '',
                selectedCompany: null,
                selectedRole: null,
                optionsRole: [
                { value: 'DESENVOLVEDOR', text: 'Desenvolvedor' },
                { value: 'ADMIN_EMPRESA', text: 'Administrador' },
                ],
                optionsCompany: [
                    { value: 'DESENVOLVEDOR', text: 'Desenvolvedor' },
                    { value: 'ADMIN_EMPRESA', text: 'Administrador' },
                    { value: 'ADMIN_CEPE', text: 'Administrador CEPE' },
                ]
            }
        },
        created() {
            this.findUser();

            const user = this.$store.getters['auth/user'];
            this.loggedUserRole = user.Role;
        },

        methods:{
            getCompanies() {
                axios.get(`${config.jsonServer}/company/getCompanies`)
                .then(response => {
                    this.companies = response.data;
                    this.setOptionsCompany();
                })
                .catch((err) => {
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Erro ao buscar empresas',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            setOptionsCompany(){
                //TODO
            },

            updateUser(){
                if(!this.name){
                    this.$bvToast.toast('Informe um nome válido.', {
                    title: 'Nome inválido',
                    variant: 'danger',
                    solid: true
                    });
                    return;
                }
                if (!this.email) {
                    this.$bvToast.toast('Informe um email válido.', {
                    title: 'Email inválido',
                    variant: 'danger',
                    solid: true
                    });
                    return;
                }
                axios.put(`${config.jsonServer}/user/update`, {
                    id_usuario: this.id,
                    nome_usuario: this.name,
                    email_usuario: this.email,
                    permissao: this.selectedRole
                }, this.headers())
                .then( () => {
                    this.$root.$bvToast.toast("O Usuário foi atualizado!", {
                        title: 'Sucesso',
                        variant: 'success',
                        solid: true
                    });
                    this.$router.push('/userManagement');
                })
                .catch( (err) =>{
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Nenhum resultado encontrado',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            findUser() {
                axios.get(`${config.jsonServer}/user/${this.id}`, 
                    this.headers()
                )
                .then(response => {
                    const user = response.data;
                    this.name = user.nome_usuario;
                    this.email = user.email_usuario;
                    this.selectedRole = user.desc_permissao;
                })
                .catch( (err) =>{
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Nenhum resultado encontrado',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            getPermission(){
                //TODO
            },

            headers(){
                const token = this.$store.getters['auth/token'].token
                const headers =  { headers:{ Authorization: 'Bearer ' + token }}
                return headers;
            }
        }       

    }
</script>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
</style>


